<p-button icon="pi pi-link" (onClick)="showDialog = true"></p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '100vh'}"
    appendTo="body"
  >
    <h2>Odaberite mjesto</h2>
    <app-odabir-mjesta (itemSelected)="onSelectedItem($event)"></app-odabir-mjesta>
  </p-dialog>
</ng-container>
